import React, { useState } from 'react';
import * as LuIcons from 'react-icons/lu';
const { LuChevronDown } = LuIcons;
import SafeIcon from '../common/SafeIcon';

export default function FAQ() {
  const faqs = [
    { q: "How does Cheapo AI work?", a: "We use a combination of web scraping and machine learning. When you paste a link, we identify the exact product and instantly scan thousands of other retailers, historical data databases, and coupon sites to compile a comprehensive saving report." },
    { q: "Which stores are supported?", a: "We support over 10,000 retailers globally, including major ones like Amazon, Walmart, Best Buy, Target, eBay, AliExpress, and Noon." },
    { q: "Is it really free?", a: "Yes! Our core feature (price comparison and basic AI advice) is 100% free for up to 5 searches per day. We offer premium plans for power users." },
    { q: "Can AI really predict price changes?", a: "Yes. By analyzing years of historical pricing data across millions of products, our AI models can identify sales cycles and predict with high accuracy when a product is likely to drop in price." },
    { q: "Does it work worldwide?", a: "Currently, our best support is for US, UK, Canada, and Australia based stores, but we are expanding rapidly. We do support global platforms like AliExpress anywhere." }
  ];

  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="py-24 bg-slate-50">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl">
        <h2 className="text-3xl md:text-4xl font-extrabold text-center text-gray-900 mb-12">Frequently Asked Questions</h2>
        
        <div className="space-y-4">
          {faqs.map((faq, idx) => (
            <div key={idx} className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-sm">
              <button 
                className="w-full px-6 py-4 text-left flex justify-between items-center font-bold text-gray-900 focus:outline-none"
                onClick={() => setOpenIdx(openIdx === idx ? -1 : idx)}
              >
                {faq.q}
                <SafeIcon 
                  icon={LuChevronDown} 
                  className={`text-gray-400 transition-transform ${openIdx === idx ? 'rotate-180' : ''}`} 
                />
              </button>
              {openIdx === idx && (
                <div className="px-6 pb-4 text-gray-600 text-sm leading-relaxed">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}